import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ProgressBarComponent from "../ProgressBarDescriptions";
import SubscoreProgressBar from "../../SubscoreProgressBar";
import CircleProgressChart from "../ReportDescCirlceChart";
import HeadlineText from "./texts/HeadlineText";
import HeadlineTextTwo from "./texts/HeadlineTextTwo";
import DescriptionTextOne from "./texts/DescriptionTextOne";
import DescriptionTextThree from "./texts/DescriptionTextThree";
import DescriptionTextTwo from "./texts/DescriptionTextTwo";
import WaterInnerStatsBar from "../../WaterInnerStatsBar";
import ExternalLinks from "../../ExternalLinks";

const DetailsContainer = styled.div`
  background: #fff;
  border: none;
  margin: 0 0 1rem 0;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
    border-bottom: 1px solid #e9ecef;
    padding: 1rem 2rem;
    width: 100%;
    border-radius: none;
    box-shadow: none;
  }
`;

const Headline = styled.h4`
  font-size: 1.2rem;
  margin-bottom: 10px;
`;

const ParametersDetails = ({ data = {}, classesTwo, t }) => {
  // const [waterDetails, setWaterDetails] = useState({});
  const [waterInM3PerTon, setWaterInM3PerTon] = useState({});
  const { name, score, categories, bonus } = data;
  const [bonusScore, setBonusScore] = useState(0);
  const [totalScore, setTotalScore] = useState(0);

  const path = window.location.pathname;

  useEffect(() => {
    if (bonus !== null) setBonusScore(bonus?.value);
  }, [bonus]);

  useEffect(() => {
    const totalScore = (score || 0) + (bonusScore || 0);
    const adjustedScore = Math.min(totalScore, 100);
    setTotalScore(adjustedScore);
  }, [score, bonusScore]);

  // Get water details
  useEffect(() => {
    if (name === "Vatten") {
      // setWaterDetails(data.waterScores || {});
      setWaterInM3PerTon(data.waterInM3PerTon || {});
    }
  }, [name, data.waterScores, data.waterInM3PerTon]);

  return (
    <DetailsContainer className={classesTwo}>
      {/* Show bonus text on sustainability report page */}
      {name === 'Klimat' && path.includes('sustainability-report') && (
        <p className="text-sm font-semibold pb-2 text-gray-500">
          {t("Poängsystem: Ett hållbart val är en produkt med hög poäng. KRAV-märkta och ekologiska produkter får bonus på parametrarna Biologisk mångfald, Bekämpningsmedel, Övergödning, Antibiotikaresistens, Djurvälfärd och Arbetsförhållanden.")}
        </p>
      )}
      <ProgressBarComponent name={name} score={score} bonus={bonus} t={t} />
      <div className="flex items-center gap-4 mb-2">
        <CircleProgressChart name={name} score={totalScore} reductionFactor={0.30} isScore={false} mtop={16} mbottom={16} t={t} />
        {name === "Klimat" && (
          <img src="/assets/images/rise.svg" className="h-12" alt={t("RISE logo")} />
        )}
        {name === "Vatten" && (
          <img src="/assets/images/WaterFootprintNetwork-header.png" className="h-12" alt={t("Water Footprint")} />
        )}
      </div>
      <div>
        <Headline>
          <HeadlineText name={name} t={t} /> {totalScore} {t("av 100")}
        </Headline>
        <DescriptionTextOne name={name} t={t} />
      </div>
      {categories?.map((category, index) => (
        <SubscoreProgressBar category={category} index={index} key={category.name} t={t} />
      ))}
      <DescriptionTextTwo name={name} score={score} avgScoreOne={null} avgScoreTwo={null} t={t} />
      <Headline>
        <HeadlineTextTwo name={name} t={t} />
      </Headline>

      {name === "Vatten" && (<WaterInnerStatsBar waterInM3PerTon={waterInM3PerTon} t={t} />)}
      <DescriptionTextThree name={name} t={t} />
      {name !== "Transport" && name !== "Landanvändning" && (<ExternalLinks name={name} t={t} />)}
    </DetailsContainer>
  );
};

export default ParametersDetails;
